import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import LinksPage from "@/pages/links/page";
import PrivacyPage from "@/pages/privacy/page";
import CookiePage from "@/pages/cookie/page";
import BusinessPage from "@/pages/business/page";
import BusinessDetailPage from "@/pages/business/detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/links",
    element: <LinksPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/cookie",
    element: <CookiePage />,
  },
  {
    path: "/business",
    element: <BusinessPage />,
  },
  {
    path: "/business/:slug",
    element: <BusinessDetailPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;